import React from "react";
class MapBlueRidgeParkway extends React.Component {
  render() {
    return (
      <React.Fragment>
        <section id="map-blue-ridge-parkway" className="about-us gray-light-bg">
          <iframe
            src="https://maps.google.com/maps?saddr=Waynesboro,+VA&daddr=Humpback+Rocks,+VA+to:Peaks+of+Otter,+VA+to:Mabry+Mill,+VA+to:Linville+Falls,+NC+to:Grandfather+Mountain,+NC+to:Asheville,+NC&output=embed"
            width="100%"
            height="420"
            title="Blue Ridge Parkway route map">
          </iframe>
        </section>
      </React.Fragment>
    );
  }
}
export default MapBlueRidgeParkway;
